import * as React from 'react';
import '@styles/pages/tab2.scss';
import { StageDefault, StageCurrent } from '@/context.ts';
import { fetch, BattleRankItem, BattleRankRsp, AreaInfo } from '@/fetch.ts';
import Page from '@hook/public/page.tsx';
import NoneData from '@hook/public/none.tsx';
import PkItem from '@hook/public/pkItem.tsx';
interface Props extends AreaInfo {
  iArea: number,
}
const { useState, useEffect, useContext } = React;

const tab2Rank3: React.FC<Props> = props => {
  const {tabCurrent} = useContext(StageDefault);
  const {current} = useContext(StageCurrent);
  const [list, List] = useState<BattleRankItem[]>([]);
  const [showList, ShowList] = useState<BattleRankItem[]>([]);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 5, (index + 1) * 5 >= list.length ? list.length : (index + 1) * 5));
  }
  useEffect(() => {
    /* 获取分区榜单 */
    fetch.getBattleRank(
      {
        iStage: current,
        iArea: props.iArea,
        lPid: 0,
      },
    )
      .then((rsp: BattleRankRsp) => {
        List(rsp.vBattleList.value.slice(0, 25));
        ShowList(rsp.vBattleList.value.length > 5 ? rsp.vBattleList.value.slice(0, 5) : rsp.vBattleList.value);
      })
  }, [current, tabCurrent])
  return (
    <div className='tab2Rank3' id={'area' + props.iArea}>
      <h1>{props.sName}</h1>
      <div className='tab2Rank3List'>
        {
          showList.length === 0 ?
            <NoneData text={'暂无数据'} />
            :
            showList.map((item: BattleRankItem) => (
              <PkItem key={Math.random()} {...item} />
            ))
        }
      </div>
      <Page
        pageLen={list.length % 5 === 0 ? list.length / 5 : Math.floor(list.length / 5) + 1}
        setPageIndex={pageChange}
      />
    </div>
  )
}
export default tab2Rank3;